import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface FooterModalButtonsProps {
  onCancel: () => void
  onConfirm: () => void
}

export const FooterModalButtons = ({ onCancel, onConfirm }: FooterModalButtonsProps) => {
  return (
    <>
      <Button type="secondary" onClick={onCancel}>
        {i18n.t('finance.reconciliations.common_modal.cancel')}
      </Button>
      <Button onClick={onConfirm}>{i18n.t('finance.reconciliations.common_modal.confirm')}</Button>
    </>
  )
}
